import React from 'react'
import { Box, Paper } from '@material-ui/core'
import TrainingPackagesContainer from 'containers/TrainingPackagesContainer'
import Navigation from './components/Navigation'

const TrainingPackagesPage = () => {
  return (
    <Paper
      component={Box}
      elevation={0}
      style={{
        padding: '10px 30px 30px 30px',
      }}
    >
      <Navigation />

      <TrainingPackagesContainer
        showAddToTrainingButton
        showTrainingPackageActions
      />
    </Paper>
  )
}

export default TrainingPackagesPage
